module.exports = __webpack_public_path__ + "img/nt51-02-80-1.prt.bc9e7a76.jpg";